module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADuSURBVHgB7VTbDcIwDDSV+GeEjtARGIENYAPYAEZgA9iAEcoGjFA26E+lNOegECOVlkbQFz+gntR+OPbd2bFCNGLEbwDAWoNTDZMoa0PqCaVUCPDFcdk8zzfPAwmUXz+RDIg0kFS4UokH8psQnctUGwZ8i7uIMPN8SpPYMVVrrlRtrab+cOBGFzWRG2OWtTorY7LWzl4SJVDMr62Ic76tkyuNo0feJKKNWbQhz8F7aoKIaM2nerGMosgBzMF3zjvqAmnVc+hWz3UYDyb/JOKRAysaAnH3hjxVbj3pG/BFTJK1WOFeInIHQ56TEX+IO6tQq2Y2nIeLAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/arrow_down.png
// module id = iXy/
// module chunks = 1